import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	slackWorkspaceConnectionSettingsHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.settings-title.slack-workspace-connection-settings-heading',
		defaultMessage: 'Settings',
		description: 'Heading for the slack settings title',
	},
	slackWorkspaceConnectionSettingsWorkspaces: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.settings-title.slack-workspace-connection-settings-workspaces',
		defaultMessage: 'WORKSPACES',
		description: 'Heading for slack workspaces',
	},
	slackConnectNewWorkspaceButton: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.settings-title.slack-connect-new-workspace-button',
		defaultMessage: 'Connect new workspace',
		description: 'Label for button connecting new workspace button',
	},
	slackWorkspaceConnectionsHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.settings-title.slack-workspace-connections-heading',
		defaultMessage: 'Connected workspaces',
		description: 'Heading for workspace connections',
	},
	msTeamsWorkspaceConnectionsHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workplace-connection-settings.settings-title.ms-teams-workspace-connections-heading',
		defaultMessage: 'Connected tenants',
		description: 'Heading for Microsoft tenant connections',
	},
});
